<mtg-hockey-league-about
  *ngIf="league.sport.isHockey()"
></mtg-hockey-league-about>
<mtg-basketball-league-about
  *ngIf="league.sport.isBasketball()"
></mtg-basketball-league-about>
<mtg-volleyball-league-about
  *ngIf="league.sport.isVolleyball()"
></mtg-volleyball-league-about>
<mtg-football-league-about
  *ngIf="league.sport.isFootball()"
></mtg-football-league-about>
<mtg-rugby-league-about
  *ngIf="league.sport.isRugby()"
></mtg-rugby-league-about>
